import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { usePortal } from '@/contexts/PortalContext';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Waves, Eye, EyeOff } from 'lucide-react';
import { toast } from 'sonner';

export default function PortalLogin() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const { login } = usePortal();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault(); setLoading(true);
    try { await login(email, password); navigate('/portal/dashboard'); toast.success('Welcome!'); }
    catch { toast.error('Invalid email or password'); }
    setLoading(false);
  };

  return (
    <div className="min-h-screen bg-[#e4f0f6] flex items-center justify-center p-4">
      <Card className="w-full max-w-md border-0 shadow-xl animate-fade-in">
        <CardHeader className="text-center pb-2">
          <div className="flex items-center justify-center gap-3 mb-4">
            <img src="/hdh-logo.png" alt="HDH" className="w-14 h-14 object-contain" />
            <div className="text-left">
              <h1 className="text-xl font-extrabold text-[#1e3a50]">HDH Pools & Spas</h1>
              <p className="text-[10px] font-bold text-[#4a9ac5] uppercase tracking-wider">Homeowner Portal</p>
            </div>
          </div>
          <CardTitle className="text-lg font-bold text-[#1e3a50]">Sign In to Your Project</CardTitle>
          <p className="text-xs font-medium text-[#6b8a9e]">View progress, photos, documents & more</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div><Label className="text-xs font-bold">Email</Label><Input type="email" value={email} onChange={e => setEmail(e.target.value)} className="h-11 rounded-sm" required data-testid="portal-email" /></div>
            <div>
              <Label className="text-xs font-bold">Password</Label>
              <div className="relative">
                <Input type={showPassword ? 'text' : 'password'} value={password} onChange={e => setPassword(e.target.value)} className="h-11 rounded-sm pr-10" required data-testid="portal-password" />
                <button type="button" onClick={() => setShowPassword(!showPassword)}
                  className="absolute right-3 top-1/2 -translate-y-1/2 text-slate-400 hover:text-slate-600 transition-colors">
                  {showPassword ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
                </button>
              </div>
            </div>
            <Button type="submit" disabled={loading} className="w-full h-11 bg-amber-500 hover:bg-amber-600 text-white font-bold uppercase tracking-wider text-xs rounded-sm" data-testid="portal-login-btn">
              {loading ? 'Signing in...' : 'Sign In'}
            </Button>
          </form>
          <div className="mt-4 pt-4 border-t border-slate-200">
          </div>
          <p className="text-center text-[10px] text-slate-400 mt-4">Your login was created by HDH Pools. Contact us if you need access.</p>
          <div className="mt-2 text-center">
            <a href="/login" className="text-xs font-bold text-amber-500 hover:text-amber-600 transition-colors">HDH Staff? Go to company login</a>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
